import React from "react";
import { Card, CardContent, Typography } from "@mui/material";
import "./styles.css";

const MINUTOS_AVISO_LARANJA = 5;

function getStatusCor(horaRemoverBanhoMaria, tempoAgora) {
  const msRemover = new Date(horaRemoverBanhoMaria).getTime();
  const msAgora = tempoAgora.getTime();
  const minutosRestantes = (msRemover - msAgora) / 60000;

  if (minutosRestantes > MINUTOS_AVISO_LARANJA) return "verde";
  if (minutosRestantes > 0) return "laranja";
  return "vermelho";
}

const CORES_STATUS = {
  verde: "#a8e6a1",
  laranja: "#ffcc80",
  vermelho: "#ff8a80",
  finalizado: "#e0e0e0",
};

function getLabelStatus(status) {
  switch (status) {
    case "verde":
      return "Recém colocado no banho";
    case "laranja":
      return "Faltam menos de 5 min para remover";
    case "vermelho":
      return "Hora de remover do banho";
    case "finalizado":
      return "Finalizado";
    default:
      return "";
  }
}

function formatarHorario(data, incluirData = false) {
  const opcoesHora = {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  };

  if (!incluirData) {
    return new Date(data).toLocaleTimeString("pt-BR", opcoesHora);
  }

  return new Date(data).toLocaleString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    ...opcoesHora,
  });
}

export default function CardAmostra({ amostra, tempoAgora, onRemoverClick }) {
  const codigoTubo = amostra.codigoTubo || "—";
  const biomeriuex = amostra.biomeriuex || "—";
  const isFinalizado = amostra.status === "removido";

  const status = isFinalizado ? "finalizado" : getStatusCor(amostra.previstoRemocaoEm, tempoAgora);
  const labelStatus = getLabelStatus(status);
  const podeRemover = !isFinalizado && (status === "vermelho" || status === "laranja");

  function handleClick() {
    if (podeRemover && onRemoverClick) onRemoverClick(amostra);
  }

  return (
    <Card
      className={`card-amostra card-amostra--${status} ${podeRemover ? "card-amostra--clicavel" : ""}`}
      sx={{ backgroundColor: CORES_STATUS[status] || "#fff" }}
      onClick={handleClick}
    >
      <CardContent className="card-amostra-conteudo">
        <Typography className="card-amostra-codigo" component="div">
          {biomeriuex}
        </Typography>
        <Typography variant="body2" component="div" sx={{ textAlign: "center", mb: 1 }}>
          tubo: {codigoTubo}
        </Typography>
        <Typography className="card-amostra-status" component="div">
          {labelStatus}
        </Typography>
        <div className="card-amostra-horarios">
          <Typography variant="body2" component="div">
            <strong>Adicionado em:</strong> {formatarHorario(amostra.inseridoEm, true)}
          </Typography>
          {isFinalizado ? (
            <Typography variant="body2" component="div">
              <strong>Finalizado às:</strong> {amostra.removidoEm ? formatarHorario(amostra.removidoEm) : "—"}
            </Typography>
          ) : (
            <Typography variant="body2" component="div">
              <strong>Remover do banho às:</strong> {formatarHorario(amostra.previstoRemocaoEm)}
            </Typography>
          )}
        </div>
      </CardContent>
    </Card>
  );
}

export { getStatusCor, getLabelStatus };
